module.exports = __webpack_public_path__ + "img/recommend_bank_img.d86407dc.png";